/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Close_ModalInputs */

const en_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close modal`)
};

const fr_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer la fenêtre`)
};

const de_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Modal schließen`)
};

const it_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi modale`)
};

const ru_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Закрыть модальное окно`)
};

const es_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar modal`)
};

const zh_cn2_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`关闭模态框`)
};

const ja_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モーダルを閉じる`)
};

const hi_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मॉडल बंद करें`)
};

const pt_pt2_close_modal = /** @type {(inputs: Close_ModalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar modal`)
};

/**
* | output |
* | --- |
* | "Close modal" |
*
* @param {Close_ModalInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const close_modal = /** @type {((inputs?: Close_ModalInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Close_ModalInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_close_modal(inputs)
	if (locale === "de") return de_close_modal(inputs)
	if (locale === "it") return it_close_modal(inputs)
	if (locale === "ru") return ru_close_modal(inputs)
	if (locale === "es") return es_close_modal(inputs)
	if (locale === "zh-CN") return zh_cn2_close_modal(inputs)
	if (locale === "ja") return ja_close_modal(inputs)
	if (locale === "hi") return hi_close_modal(inputs)
	if (locale === "pt-PT") return pt_pt2_close_modal(inputs)
	return en_close_modal(inputs)
});